export const getAssociateloading = (state) => state.adminR.isLoading;
export const getAssociate = (state) => state.adminR.associate;
export const getAssociateFetchLoading= (state) => state.adminR.isCreateAssociateServiceLoading;
export const getAssociateServiceData = (state) => state.adminR.associateServiceData;
export const getCreateAssociateServiceLoading = (state) => state.adminR.isCreateAssociateServiceLoading;